import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetAccountGroupsShareInvitedRequestModel, GetAccountGroupsShareInvitedResponseModel } from "@/features/accounts/account-group/services/get-account-groups-share-invited-model";

export class GetAccountGroupsShareInvitedApi {
  /**
   * 口座グループ共有招待情報取得
   */
  public getAccountGroupsShareInvited = async (
    param: GetAccountGroupsShareInvitedRequestModel
  ): Promise<GetAccountGroupsShareInvitedResponseModel[]> => {
    const path = `/api/accountgroups/share/invited`;
    const res = await ApiClient.instance.get<GetAccountGroupsShareInvitedResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
